<template>
  <v-container class="page-login" fill-height>
    <v-row>
      <v-col>
        <v-card class="pa-3 page-login__card">
          <v-card-title>
            <v-spacer></v-spacer>
            <img
              src="/static/logo.svg"
              alt="Lab On Locale Portable"
            />
            <v-spacer></v-spacer>
          </v-card-title>

          <v-card-text>
            <v-form name="form" class="my-10" @submit.prevent="handleLogin">
              <v-text-field
                v-model="user.username"
                v-validate="'required'"
                append-icon="mdi-account-circle"
                :rules="[rules.required]"
                type="text"
                name="username"
                label="Username"
                solo
                autofocus
              ></v-text-field>

              <v-text-field
                v-model="user.password"
                v-validate="'required'"
                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="[rules.required]"
                :type="show ? 'text' : 'password'"
                name="password"
                label="Password"
                solo
                @click:append="show = !show"
                @keyup.enter.native="handleLogin"
              ></v-text-field>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  text
                  large
                  v-bind="attrs"
                  v-on="on"
                >
                  New User?
                  <v-icon right>mdi-menu-down</v-icon>
                </v-btn>
              </template>
              
              <v-list>
                <v-list-item href="/static/doc/lol-portable-user-manual.pdf" target="_blank">
                  <v-list-item-title>
                    <v-icon left>
                      mdi-book-open-outline
                    </v-icon>
                    User Manual
                  </v-list-item-title>
                </v-list-item>

                <v-list-item @click="newUser()">
                  <v-list-item-title>
                    <v-icon left>
                      mdi-school-outline
                    </v-icon>
                    Exam
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-spacer />

            <v-btn
              large
              color="primary"
              @click="handleLogin"
              :loading="loading"
            >
              {{ $vuetify.lang.t('$vuetify.login') }}
            </v-btn>

            
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import User from '../../models/user';

export default {
  name: 'Login',
  data() {
    return {
      user: new User('',''),
      loading: false,
      message: '',
      show: false,
      rules: {
          required: value => value.length != 0 || 'Required'
          //min: v => v.length  || 'Minimum 8 characters',
        // password: [
        //   v => !!v || 'Password is required',
        //   v => (v && v.length >= 8) || 'Password must have at least 8 characters',
        //   v => /(?=.*[A-Z])/.test(v) || 'Must have at least one uppercase character',
        //   v => /(?=.*\d)/.test(v) || 'Must have at least one number',
        //   v => /([!@$%])/.test(v) || 'Must have at least one special character [!@#$%]'
        // ],
        // username: [
        //   v => !!v || 'Username is required',
        // ]
        }
    }
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    }
  },
  created() {
    if (this.loggedIn) {
      this.$router.push('/dashboard');
    }
  },
  methods: {
    handleLogin() {
      this.loading = true;
      this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          this.loading = false;
          return;
        }

        if (this.user.username && this.user.password) {
          this.$store.dispatch('auth/login', this.user).then(
            () => {
              // this.$router.push('/dashboard');
              window._LOL2P.$emit('LOGGED_IN')
              setTimeout(() => this.$router.push('/dashboard'), 1000)
            },
            error => {
              this.loading = false;
              this.message =
                (error.response && error.response.data) ||
                error.message ||
                error.toString();
              window._LOL2P.$emit('SHOW_SNACKBAR', {
                text: this.message.message,
                color: 'error'
              })
            }
          );
        }
      });
    },

    userManual() {
      // window.open("http://www.labonlocale.com/portable-manual/")
      this.$router.push('/newuser/manual')
    },

    newUser() {
      this.$router.push('/newuser/exam')
    }
  }
}
</script>

<style lang="sass" scoped>
.page-login
  &__card
  max-width: 600px
  margin: 0 auto
</style>
